(() => {
  'use strict';

  const elementName = 'upsell-recommendations';
  const urlAttribute = 'data-url';
  const sliderAttribute = 'data-slider';

  class UpsellRecommendations extends HTMLElement {
    connectedCallback() {
      const observer = new IntersectionObserver(
        (entries, instance) => {
          if (!entries[0].isIntersecting) {
            return;
          }

          instance.unobserve(this);

          if (!this.hasAttribute(urlAttribute) || this.getAttribute(urlAttribute) === '') {
            return;
          }

          fetch(this.getAttribute(urlAttribute))
            .then((response) => response.text())
            .then((html) => {
              const wrapper = document.createElement('div');
              wrapper.innerHTML = html;

              const source = wrapper.querySelector(elementName);
              if (!source || source.innerHTML.trim().length === 0) {
                return;
              }

              this.innerHTML = source.innerHTML;

              if (this.hasAttribute(sliderAttribute)) {
                this.dispatchEvent(
                  new CustomEvent('theme:complementary:loaded', {
                    bubbles: true,
                    detail: {container: this}
                  })
                );
              }
            })
            .catch((error) => {
              console.error(error);
            });
        },
        {rootMargin: '0px 0px 400px 0px'}
      );

      observer.observe(this);
    }
  }

  if (!customElements.get(elementName)) {
    customElements.define(elementName, UpsellRecommendations);
  }
})();
